import type { HeadlineSmallOneLineProps } from './types';
import {
  Headline,
  HeadlineRightPanel,
  IconChevronRight,
  TextButton,
} from '@banhala/ui-kit';
import {
  bridge,
  convertDeeplinkToWebLink,
  getWebBaseURL,
} from '../../../../utils';
import { ABLY_INFO } from '../../../../constant/ablyInfo';
import type { IScreensLogging } from '../../../../api/types';

export const HeadlineSmallOneLine = ({ header }: HeadlineSmallOneLineProps) => {
  if (!header) {
    return null;
  }
  const isRoutable = header.item.deeplink !== null;

  const handleClickViewAllButton = () => {
    const { deeplink } = header.item;
    if (deeplink === null) {
      return;
    }

    logClickViewAllButton({ logging: header.logging });

    bridge.openDeeplink(deeplink, {
      webCallback: async () => {
        const baseURL = await getWebBaseURL();
        const convertedLink = convertDeeplinkToWebLink(deeplink);
        if (convertedLink === ABLY_INFO.url) {
          location.href = ABLY_INFO.url;
          return;
        }
        location.href = `${baseURL}${convertedLink}`;
      },
    });
  };

  return (
    <>
      <Headline
        size="medium"
        headline={header.item.title}
        testID={header.item.title}
        rightPanel={
          <>
            {isRoutable && (
              <HeadlineRightPanel type={'textButton'}>
                <TextButton
                  size={'medium'}
                  color={'blue'}
                  onPress={handleClickViewAllButton}
                  icon={<IconChevronRight />}
                >
                  전체보기
                </TextButton>
              </HeadlineRightPanel>
            )}
          </>
        }
      />
    </>
  );
};

const logClickViewAllButton = ({ logging }: { logging: IScreensLogging }) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_HEADLINE_SMALL_ONE_LINE_MORE',
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
};
